import React from "react";
import ConfettiExplosion from "react-confetti-explosion";

const Success = () => {
  return (
    <span className="font-normal">
      PERFECT SCORE!
      <ConfettiExplosion />
    </span>
  );
};

const ScoreViewer = ({ specificScore }) => {
  return (
    <span className="ml-4 text-success-600 flex gap-4 w-fit">
      +{specificScore}
      {specificScore === 2500 && <Success />}
    </span>
  );
};

export default ScoreViewer;
